<template>
<transition name="fade">
    <div class="modal coupon-modal">
        <div class="backdrop"></div>
        <div class="coupon-container">
            <coupon-card :code="content.code" :id="content.couponId" :title="content.title" :description="content.description" @use="useCoupon" />
            <div class="x-container cursor-pointer" @click="closeModal()">
                <div class="x-bg"></div>
                <i class="fas fa-times-circle shadow-text-none"></i>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
import CouponCard from "@/components/CouponCard";
export default {
    props: {
        content: {
            type: Object,
            required: true
        }
    },

    components: {
        CouponCard,
    },

    data() {
        return {
            showModal: false,
            couponTitle: null,
            couponDescription: null
        }
    },

    methods: {
        closeModal() {
            this.$emit('close')
        },

        useCoupon(code) {
            this.$emit('use', code)
            this.$emit('coupon', this.content.coupon_id)
            this.$emit('close')
        },
    }
};
</script>

<style lang="scss">
.coupon-modal {
    width: 100%;
    height: 100%;
    padding: 1rem;

    .backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    .coupon-container {
        position: relative;
        z-index: 2;

        @media screen and (max-width: 767px) {
            width: 100%;
        }

        .x-container {
            position: absolute;
            top: -13px;
            right: -14px;
            width: 28px;
            height: 28px;

            .x-bg {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 16px;
                height: 16px;
                background-color: #fff;
                z-index: 1;
            }

            i {
                position: absolute;
                top: 0;
                left: 0;
                font-size: 28px;
                color: #000;
                z-index: 2;
            }
        }
    }
}
</style>
